<template>
  <div class="vx-row mb-2 -mt-1">
    <div class="vx-col w-full">
      <span class="text-xs">{{fieldLabel}}</span>
      <br />
      <flat-pickr :config="configdateTimePicker" v-model="localVal" />
      <span class="text-danger text-sm" v-show="errors.has('field')">{{ errors.first('field') }}</span>
    </div>
  </div>
</template> 
<script>
import Datepicker from "vuejs-datepicker";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { sidebarMixin } from "../sidebarMixin";
export default {
  mixins: [sidebarMixin],

  components: {
    flatPickr,
  },

  props: {
    index: String,
    structure: {
      type: Object,
      default: () => {},
      required: true,
    },
    value: String,
    validation: "",
  },

  data() {
    return {
      noCalendar: true,
      localVal: new Date(),
      name: "",
      currentValueOfShowHideField: true, //this is to retain the current value of show and hide
      time: null,
      configdateTimePicker: {
        enableTime: true,
        enableSeconds: false,
        enableMinutes:false,
        noCalendar: true,
        minuteIncrement: 30,
         dateFormat: "H",
      },
    };
  },

  created() {
    if (this.value == undefined) {
      var thedate = new Date();
      var split = thedate.toTimeString().split(" ");
      console.log("timeeeeee:", split);
      this.localVal = split[0];
    } else {
      this.localVal = this.value;
    }

    if (this.localVal != "") {
      this.$emit("error", { index: this.index, value: true });
      console.log("time:", this.local);
      this.$emit("input", { index: this.index, value: this.localVal });
    }

    this.$watch("localVal", (value) => {
      if (value != "") {
        this.$emit("input", { index: this.index, value: value });
        this.$emit("error", { index: this.index, value: true });
      } else {
        this.$emit("error", { index: this.index, value: false });
      }
    });
  },

  methods: {
    changeHandler() {
      // this.$emit("error", this.errors.errors);
      this.$validator.validateAll().then((result) => {
        this.$emit("error", { index: this.index, value: result });
      });
    },
  }
};
</script>

